import { useContext } from "react";
import Actions from "../../data/Transactions.json";
import Routes from "../../data/routes.json";
import { CurrentTime } from "../current";
import { auth } from "../../context/auth";
import { v4 as uuidv4 } from 'uuid';

export function useTransaction(action, message="", expection = false) {
    const {ActivEmp} = useContext(auth);

    const route = window.location.pathname;

    const decision = {
        status: false,
        message: ""
    };

    if (!action || !route) {
        decision.message = "route or action is undefined";
        return { decision };
    }

    if (!Array.isArray(Actions) || !Array.isArray(Routes)) {
        decision.message = "Actions or Routes is not an array";
        return { decision };
    }

    if (!Actions.includes(action) || !Routes.includes(route) && !expection) {
        decision.message = "invalid route or action";
        return { decision };
    }

    const currentTime = CurrentTime();
    const date = new Date(currentTime);

    if (isNaN(date.getTime())) {
        decision.message = "invalid date";
        return { decision };
    }

    decision.status = true;

    const data = {
        id: uuidv4(),
        person: ActivEmp || "unknown",
        LOC: route,
        action: action,
        current: currentTime,
        message: message,
        async: {
            status: 'f',
            reason: "new"
        },
    };

    return { decision, data };
}